export const IMAGE_PLACEHOLDER = 'Bodymod-Icon-white';
